<template>
  <div class="mh-treeMenu-item">
    <!-- Button -->
    <div class="mh-treeMenu-item__button">
      <div :class="[{ 'button-content': true }, {'leaf': isLeaf }]">
        <div class="button__text" @click="toggleOpen">
          <slot v-bind="{item, isLeaf, isOpen}">
            <ArrowIcon v-if="isLeaf == false" :size="'small'" :direction="arrowDirection" />
            <i v-if="isLeaf == false" :class="[{ 'fa' : true}, { 'fa-folder': !isOpen } , { 'fa-folder-open': isOpen }]" style="color: #ffd26a;" />
            <i v-if="isLeaf == true" :class="[{ 'fa' : true}, { 'fa-file': true }]" style="color: #6c757d;" />
            <div>{{ item.name }}</div>
          </slot>
        </div>
      </div>
    </div>

    <!-- Children -->
    <div class="mh-treeMenu-item__children" v-if="isOpen && item.children">
      <MenuItem
        v-for="(child, index) in item.children"
        :key="child.name + index"
        :item="child"
        :on-select="onSelect"
      >
        <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
        <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"><slot :name="name" v-bind="slotData" /></template>
      </MenuItem>
    </div>
  </div>
</template>

<script>
import ArrowIcon from "../ArrowIcon";
import DropdownItem from "../dropdown/DropdownItem";

export default {
  name: "MenuItem",
  components: { ArrowIcon, DropdownItem },
  props: {
    onSelect: null,
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: this.item.isOpen || false,
      isContext: false,
      isEditing: false,
      edit: this.item.name || "",
    };
  },
  computed: {
    arrowDirection() {
      return this.isOpen ? "bottom" : "right";
    },
    isLeaf(){
      return this.item.hasOwnProperty("children") === false || (this.item.hasOwnProperty("children") && this.item.children.length == 0 ) 
    }
  },
  methods: {
    toggleOpen(e) {
      if(e.target.tagName != "A"){
        this.isOpen = !this.isOpen;
        this.onSelect(this.item)
      }
    },
    toggleContext() {
      this.isContext = !this.isContext;
    },
    onEnter({ keyCode }) {
      if (keyCode === 13) this.setEdit(false);
    },
    focus() {
      if (this.$refs.inputRef) {
        this.$refs.inputRef.focus();
      }
    },
    setEdit(val = true) {
      this.isEditing = val;
      this.$nextTick(this.focus);
    },
    onSave(value) {
      console.log("Saving data", this.edit);
    }
  }
};
</script>

<style>
.mh-treeMenu-item .button-content {
  display: flex;
  width: 100%;
  display: flex;
  align-items: center;
  height: 2.4rem;
  margin: 0.3rem 0;
  padding: 0 0.4rem 0 0.6rem;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
}
.mh-treeMenu-item .button-content.leaf {  padding-left: 0; }

.mh-treeMenu-item .button-content:hover {
  background-color: #0000000f;
}

.mh-treeMenu-item .button-context__button {
  cursor: pointer;
  width: 1rem;
  height: 1rem;
  padding: 0.6em;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: grey;
}

.mh-treeMenu-item .button__text {
  flex-grow: 1;
  display: flex;
  align-items: center;
  height: 100%;
}

.mh-treeMenu-item .button__text input {
  width: 100%;
}

.mh-treeMenu-item .button__text > i {
  margin: 0 0.36em 0 0.6em;
}
.mh-treeMenu-item__children {
  padding-left: 0.8em;
  margin-left: 0.8em;
  border-left: 1px solid #ddd;
}
</style>
